import React, { createContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

import { api, authHeaders } from '../services/api'
import { descriptografar } from '../util/crypto'
import { clienteData } from '../util/client-data'

export const GlobalContext = createContext()

const GlobalProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [clienteRobot, setClienteRobot] = useState(null)

    const history = useHistory()

    async function loadRobotCliente() {
        setClienteRobot(clienteData?.customer)
    }

    function handleLogout() {
        api.post('sessao/logout', {}, authHeaders())

        sessionStorage.removeItem(process.env.REACT_APP_SESSION_STORAGE_TOKEN)
        sessionStorage.removeItem(process.env.REACT_APP_SESSION_STORAGE_USER)
        sessionStorage.removeItem('sigas-project-file-explorer-agreement')

        setUser(null)

        history.push('/')
    }

    function checkException(e, options) {
        let logout = true

        if(options?.logout === false) {
            logout = false
        }
    
        if(e?.session_is_expired) {
            toast.warn('Sua sessão expirou.')

            if(logout) {
                handleLogout()
            }
        } else if(e?.msg) {
            toast.error(e.msg)
        } else {
            // toast.error('Ocorreu um erro inesperado.')
        }
    }

    useEffect(() => {
        loadRobotCliente()
    }, [])

    useEffect(() => {
        const storedUser = descriptografar(sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_USER))

        setUser(storedUser || null)
    }, [])

    async function reload() {
        if (user) {
            const response = await api.get('usuario', authHeaders())

            const storedUser = descriptografar(sessionStorage.getItem(process.env.REACT_APP_SESSION_STORAGE_USER))

            setUser({
                ...storedUser,
                avatar: response.avatar.link
            })
        }
    }

    return (
        <GlobalContext.Provider value={{
            user,
            setUser,
            reload,
            clienteRobot,
            handleLogout,
            checkException
        }}
        >
            {clienteRobot ? children : null}
        </GlobalContext.Provider>
    )
}

export default GlobalProvider
